import type { GetV1200, GetV1QueryResponse } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

/**
 * @description Tasks API Index
 */
export const getV1200Schema = z.object({
  message: z.string(),
}) as unknown as ToZod<GetV1200>

export type GetV1200Schema = GetV1200

export const getV1QueryResponseSchema = z.lazy(() => getV1200Schema) as unknown as ToZod<GetV1QueryResponse>

export type GetV1QueryResponseSchema = GetV1QueryResponse